<template>
  <div class="submissions">
    <p v-if="!localSubs.length">No submissions yet</p>

    <ul v-else class="list-plain">
      <li
        v-for="submission in localSubs"
        :key="submission.address"
        class="grid column-gap grid-3-columns@sm grid-4-columns@md mb-4"
      >
        <!-- TODO: Bookmark -->
        <div class="mb-1" :title="submission.owner">
          <MtxBlockie :input="submission.owner.toLowerCase()" class="mr-1" />

          <RouterLink :to="{ name: 'UserProfile', params: { userAddress: submission.owner } }">
            {{ submission.owner | ethAddress }}
          </RouterLink>
        </div>

        <div class="column-span-2@sm column-span-3@md flex align-center">
          <div class="flex-grow mr-2">
            <h6 class="mb-1">{{ submission.title }}</h6>
            <p>
              {{ submission.description | truncate }}
              <RouterLink
                :to="{ name: 'SubmissionsSingle', params: { submissionHash: submission.hash } }"
              >
                View submission
              </RouterLink>
            </p>
          </div>

          <MtxInput
            v-if="selectable"
            v-model="submission.selected"
            @change="$emit('submissionToggled', submission)"
            type="checkbox"
            label="Test"
            hideLabel
          />

          <div v-else-if="submission.reward" class="flex flex-shrink-0 align-center">
            <MtxSvg class="flex-shrink-0 mr-1" icon="icon-trophy" />
            {{ submission.reward | mtx }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    submissions: {
      type: Array,
      required: true
    },
    selectable: Boolean
  },

  data: () => ({
    localSubs: null
  }),

  watch: {
    submissions: {
      handler() {
        this.localSubs = this.submissions
          .map(sub => ({
            ...sub,
            selected: false
          }))
          .sort((a, b) => {
            let total = b.reward - a.reward

            if (total === 0) {
              total = b.timestamp - a.timestamp
            }

            return total
          })
      },
      immediate: true
    }
  }
}
</script>
